/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the `lang` is invalid
 * @export
 * @class I18nInvalidLangError
 * @extends {Error}
 */
export class I18nInvalidLangError extends Error {
  /**
   * Creates an instance of I18nInvalidLangError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLangError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLangError`;
  }
}

/**
 * Called when the `lang` is invalid
 * @param {any} lang The invalid `lang`
 * @param {Array<I18nEntityLocale>} locales The valid list of locales
 * @returns {never} never
 */
const throwI18nInvalidLangError = (lang, locales) => {
  if (locales.length === 0) {
    throw new I18nInvalidLangError(
      stripIndent(`
      Invalid "lang". Expected "${locales[0].lang}".
      Got: "${lang}"
      `),
    );
  }
  const startLangs = locales.slice(0, -1).map((locale) => locale.lang);
  const endLang = locales.slice(-1)[0].lang;
  throw new I18nInvalidLangError(
    stripIndent(`
    Invalid "lang". Expected one of "${startLangs.join(`", "`)}", or "${endLang}".
    Got: "${lang}"
    `),
  );
};

export default throwI18nInvalidLangError;
